<template>
	<div class="container">
		<div class="row">
			<div class="col-lg-12">
				<div class="page-header">
					<h1>Map</h1>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-lg-12">
				<v-map :zoom="zoom" :center="center" style="height:40em">
					<v-tilelayer :url="url" :attribution="attribution"></v-tilelayer>
					<v-marker v-for="item in markers" :key="item.name" :lat-lng="item.position" :icon="item.icon">
						<v-popup :content="item.popup"></v-popup>
					</v-marker>
					<v-polyline v-for="item in lines" :key="item.name" :lat-lngs="item.position" :color="item.color"></v-polyline>
				</v-map>
			</div>
		</div>

		<div class="row">
			<div class="col-lg-12">
				<h2>Settings</h2>
				<div class="checkbox">
					<label><input type="checkbox" v-model="settings.widerangeOnly"> Show Widerange-transmitter only</label><br />
					<label><input type="checkbox" v-model="settings.showNodes"> Show nodes</label><br />
					<label v-if="settings.showNodes"><input type="checkbox" v-model="settings.showLines"> Show line from transmitter to node</label>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Vue2Leaflet from 'vue2-leaflet';
	import L from 'leaflet';
	import '../../../node_modules/leaflet/dist/leaflet.css';
	Vue.component('v-map', Vue2Leaflet.Map);
	Vue.component('v-tilelayer', Vue2Leaflet.TileLayer);
	Vue.component('v-marker', Vue2Leaflet.Marker);
	Vue.component('v-popup', Vue2Leaflet.Popup);
	Vue.component('v-polyline', Vue2Leaflet.Polyline);

	export default {
		created() {
			this.createMap();
		},
		data() {
			return {
				settings: {
					widerangeOnly: true,
					showNodes: false,
					showLines: false
				},
				zoom: this.$store.getters.map.zoom,
				center: this.$store.getters.map.center,
				attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>',
				url: this.$store.getters.url.map,
				markers: [],
				lines: []
			};
		},
		methods: {
			createMap() {
				let iconNodeOnline = L.icon({
					iconUrl: './assets/img/marker-node-online.png',
					iconSize: [30, 30],
					iconAnchor: [15, 15],
					popupAnchor: [0, 0]
				});

				let iconNodeSuspended = L.icon({
					iconUrl: './assets/img/marker-node-suspended.png',
					iconSize: [30, 30],
					iconAnchor: [15, 15],
					popupAnchor: [0, 0]
				});

				let iconNodeUnknown = L.icon({
					iconUrl: './assets/img/marker-node-unknown.png',
					iconSize: [30, 30],
					iconAnchor: [15, 15],
					popupAnchor: [0, 0]
				});

				let iconTransmitterOnline = L.icon({
					iconUrl: './assets/img/marker-transmitter-online.png',
					iconSize: [28, 30],
					iconAnchor: [15, 30],
					popupAnchor: [0, -25]
				});

				let iconTransmitterOffline = L.icon({
					iconUrl: './assets/img/marker-transmitter-offline.png',
					iconSize: [28, 30],
					iconAnchor: [15, 30],
					popupAnchor: [0, -25]
				});

				this.$http.get('nodes').then(response => {
					const allNodes = response.body;

					// get node markers
					let markerNodes = [];
					response.body.forEach(node => {
						// find icon
						let selectedMarkerIcon = iconNodeOnline;
						if (node.status === 'SUSPENDED') {
							selectedMarkerIcon = iconNodeSuspended;
						} else if (node.status !== 'ONLINE') {
							selectedMarkerIcon = iconNodeUnknown;
						}

						// set ip-address (if applicable)
						let popupIp = '';
						if (node.address !== null) {
							popupIp = '<br />IP: ' + node.address.ip_addr + ':' + node.address.port;
						}

						// build marker
						if (this.settings.showNodes) {
							markerNodes.push({
								name: node.name,
								position: {
									lat: node.latitude,
									lng: node.longitude
								},
								popup: '<b>' + node.name + '</b>' + popupIp,
								icon: selectedMarkerIcon
							});
						}
					});

					// get transmitter markers
					this.$http.get('transmitters').then(response => {
						let markerTransmitters = [];
						let polylineTransmitters = [];

						response.body.forEach(transmitter => {
							// check for widerange-setting
							if (this.settings.widerangeOnly && transmitter.usage !== 'WIDERANGE') {
								return true;
							}

							// find icon
							let selectedMarkerIcon = iconTransmitterOnline;
							if (transmitter.status !== 'ONLINE') {
								selectedMarkerIcon = iconTransmitterOffline;
							}

							// build marker
							markerTransmitters.push({
								name: transmitter.name,
								position: {
									lat: transmitter.latitude,
									lng: transmitter.longitude
								},
								popup: '<b>' + transmitter.name + '</b><br />Transmission Power (W): ' + transmitter.power + '<br />Timeslot: ' + transmitter.timeSlot,
								icon: selectedMarkerIcon
							});

							// build line to node
							if (this.settings.showLines && this.settings.showNodes) {
								allNodes.forEach(node => {
									if (node.name === transmitter.nodeName) {
										polylineTransmitters.push({
											name: transmitter.name,
											position: [[node.latitude, node.longitude], [transmitter.latitude, transmitter.longitude]],
											color: this.$helpers.stringToColor(node.name)
										});
									}
								});
							}
						});

						this.markers = markerNodes.concat(markerTransmitters);
						this.lines = polylineTransmitters;
					});
				});
			}
		},
		watch: {
			'settings.widerangeOnly'() {
				this.createMap();
			},
			'settings.showNodes'() {
				if (!this.showNodes) {
					this.settings.showLines = false;
				}
				this.createMap();
			},
			'settings.showLines'() {
				this.createMap();
			}
		}
	};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Map.vue?248406af